<rappider-title-toolbar [mainTitle]="mainTitleConfig"
                        [options]="titleBreadCrumbItems">
</rappider-title-toolbar>

<section>
  <rappider-crud-view-edit-form [config]="AI_FUNCTION_FORM_CONFIG"
                                [submitButtonLoading]="isLoading"
                                (formSubmit)="saveAiFunction($event)">
  </rappider-crud-view-edit-form>
  <!-- [data]="editedComment" -->
</section>
